import http from "./http-common";
import ServiceModel from "../models/service";

// Navbar APIs
// eslint-disable-next-line
export default new (class ServiceService {
  // Get all members
  async getService() {
    return await http
      .get("/services?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((service) => ServiceModel.get(service))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get by Id
  async getServiceByName(name) {
    return await http
      .get("/services?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data
            .filter((i) => i.link.href === name)
            .map((service) => ServiceModel.get(service))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
